module.exports = __webpack_public_path__ + "img/circle-plus.f6e8d6cc.svg";